import styled, { css } from 'styled-components';
import WhoAreWe01 from '../../assets/Group-793.png';
import WhoAreWe02 from '../../assets/whoArewe02.png';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';

const images = [
  { src: WhoAreWe01, alt: 'Image 1' },
  { src: WhoAreWe02, alt: 'Image 2' },
];

const Section = styled.div`
  padding: 1.5rem;
  @media (min-width: 768px) {
    padding: 5rem;
  }
`;

const Title = styled.h1`
  font-size: 1.875rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-align: left;
  color: #b45309;
  padding-bottom: 1.5rem;
`;

const Paragraph = styled.p`
  font-size: 1.125rem;
  margin-bottom: 2rem;
  text-align: justify;
  color: #374151;
  & span {
    font-weight: inherit;
  }
`;

const ArrowStyles = css`
  .splide__arrow {
    top: 50%;
    transform: translateY(-50%);
    width: 2.5rem;
    height: 2.5rem;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    color: #b45309;
    border: 1px solid #eee;
    opacity: 0.9;
    z-index: 2;
  }
  .splide__arrow--prev {
    left: calc(17%);
  }
  .splide__arrow--next {
    right: calc(17%);
  }
  .splide__arrow svg {
    width: 1.2rem;
    height: 1.2rem;
  }
  @media (max-width: 900px) {
    .splide__arrow--prev {
      left: 2%;
    }
    .splide__arrow--next {
      right: 2%;
    }
  }
`;

const CarouselWrapper = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  ${ArrowStyles}
`;

const StyledImg = styled.img`
  width: 66%;
  height: auto;
  max-height: 624px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  object-fit: cover;
  border-radius: 2rem;
  @media (max-width: 900px) {
    width: 95%;
    border-radius: 1rem;
  }
`;

export default () => {
  return (
    <Section>
      <Title>Who are we?</Title>
      <Paragraph>
        At Sensforge, we make smart tech part of daily life. Our AI-powered cameras—built entirely in-house, from hardware to software—keep you safe and ready to capture every moment, whether at home or on the go.
      </Paragraph>
      <Paragraph>
      We believe the most meaningful moments aren't posed. They're spontaneous, emotional, and often missed. Sensforge combines AI and smart cameras to help everyone stay present while their most important memories are captured automatically.      </Paragraph>
      <Paragraph>
        <span style={{ fontWeight: 'bold' }}>Smarter cameras,</span> easier living.
      </Paragraph>
      <CarouselWrapper>
        <Splide
          options={{
            rewind: true,
            gap: '40px',
            type: 'loop',
            focus: 'center',
            autoWidth: false,
            autoplay: true,
            interval: 5000,
            start: 0,
            perPage: 1,
            arrows: true,
            pagination: true,
            direction: 'ltr',
            scrollbar: false,
          }}
        >
          {images.map((item, index) => (
            <SplideSlide key={index}>
              <StyledImg
                src={item.src}
                alt={item.alt}
              />
            </SplideSlide>
          ))}
        </Splide>
      </CarouselWrapper>
    </Section>
  );
};
